import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import useApiStable from '../utils/useApiStable';

const VerifyEmail = () => {
  const api = useApiStable();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [resendEmail, setResendEmail] = useState('');
  const [resendStatus, setResendStatus] = useState('');
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Der Verifikationslink ist unvollständig.');
      return;
    }

    const verify = async () => {
      try {
        const response = await api.fetchRaw(`/auth/verify-email?token=${encodeURIComponent(token)}`, {
          method: 'GET',
        });
        const data = await response.json();
        setStatus('success');
        setMessage(data.message || 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt.');
      } catch (error) {
        setStatus('error');
        setMessage(error.message || 'Die E-Mail-Adresse konnte nicht bestätigt werden.');
      }
    };

    verify();
  }, [api, searchParams]);

  const handleResend = async (e) => {
    e.preventDefault();
    setIsResending(true);
    setResendStatus('');
    try {
      await api.fetchRaw('/auth/resend-verification', {
        method: 'POST',
        body: JSON.stringify({ email: resendEmail.trim() })
      });
      setResendStatus('E-Mail wurde gesendet. Bitte prüfen Sie Ihr Postfach.');
    } catch {
      setResendStatus('E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: '520px', margin: '50px auto', padding: '0 20px' }}>
      <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>E-Mail bestätigen</h2>

        {status === 'loading' && <p style={{ textAlign: 'center' }}>Bestätigung wird geprüft...</p>}

        {status === 'success' && (
          <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '12px', borderRadius: '4px', marginBottom: '20px' }}>
            {message}
          </div>
        )}

        {status === 'error' && (
          <>
            <div style={{ background: '#ffebee', color: '#c62828', padding: '12px', borderRadius: '4px', marginBottom: '24px' }}>
              {message}
            </div>

            <p style={{ fontSize: '0.9em', color: '#555', marginBottom: '12px' }}>
              Neuen Bestätigungslink anfordern:
            </p>

            <form onSubmit={handleResend}>
              <input
                type="email"
                value={resendEmail}
                onChange={(e) => setResendEmail(e.target.value)}
                placeholder="Ihre E-Mail-Adresse"
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '0.95em',
                  boxSizing: 'border-box',
                  marginBottom: '10px'
                }}
              />

              {resendStatus && (
                <div style={{
                  background: resendStatus.includes('gesendet') ? '#e8f5e9' : '#ffebee',
                  color: resendStatus.includes('gesendet') ? '#2e7d32' : '#c62828',
                  padding: '10px',
                  borderRadius: '4px',
                  marginBottom: '10px',
                  fontSize: '0.9em'
                }}>
                  {resendStatus}
                </div>
              )}

              <button
                type="submit"
                disabled={isResending}
                style={{
                  width: '100%',
                  padding: '10px',
                  background: isResending ? '#90a4ae' : '#1976d2',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '0.95em',
                  cursor: isResending ? 'not-allowed' : 'pointer',
                  fontWeight: '500',
                  marginBottom: '20px'
                }}
              >
                {isResending ? 'Wird gesendet...' : 'Bestätigungs-E-Mail senden'}
              </button>
            </form>
          </>
        )}

        <div style={{ textAlign: 'center' }}>
          <Link to="/login" style={{ color: '#1976d2', textDecoration: 'none', fontWeight: '500' }}>
            Zum Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;

